import { render, staticRenderFns } from "./DocumentsDialog.vue?vue&type=template&id=7a6467f1&scoped=true&"
import script from "./DocumentsDialog.vue?vue&type=script&lang=js&"
export * from "./DocumentsDialog.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsDialog.vue?vue&type=style&index=0&id=7a6467f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6467f1",
  null
  
)

export default component.exports